/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBarberProfileOutput } from "../../entities/models/BarberProfileOutput";
import { modelsShiftSchema } from "./shiftSchema";
import { z } from "zod/v4";

export const modelsBarberProfileOutputSchema = z.object({
    get "actual_shift"(){
                return modelsShiftSchema.optional()
              },
"barber_id": z.optional(z.int()),
"branch_id": z.optional(z.int()),
"daily_haircuts": z.optional(z.int()),
"name": z.optional(z.string()),
"photo_url": z.optional(z.string()),
"total_haircuts": z.optional(z.int())
    }) as unknown as z.ZodType<ModelsBarberProfileOutput>